import { Link } from "react-router-dom";
import { LEGAL_FOOTNOTE, COMPANY } from "@/lib/legal-content";

const FOOTER_GROUPS = [
  {
    heading: "Product",
    links: [
      { to: "/", label: "About TeeBee" },
      { to: "/marketplace", label: "Marketplace" },
      { to: "/explore", label: "Explore" },
      { to: "/about", label: "About Factskoot" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { to: "/legal", label: "Legal & Trust Center" },
      { to: "/legal/terms", label: "Terms" },
      { to: "/legal/privacy", label: "Privacy Policy" },
      { to: "/legal/refund-policy", label: "Refund Policy" },
      { to: "/legal/shipping-delivery", label: "Shipping / Delivery" },
      { to: "/legal/pricing-billing", label: "Pricing & Billing" },
      { to: "/legal/cookie-policy", label: "Cookie Policy" },
    ],
  },
  {
    heading: "Marketplace & AI",
    links: [
      { to: "/legal/coins-policy", label: "TeeBee Coins Policy" },
      { to: "/legal/marketplace-policy", label: "Marketplace Policy" },
      { to: "/legal/recruiter-policy", label: "Recruiter Policy" },
      { to: "/legal/profile-visibility-policy", label: "Profile Visibility" },
      { to: "/legal/ai-disclaimer", label: "AI Disclaimer" },
      { to: "/legal/content-policy", label: "Content Policy" },
    ],
  },
  {
    heading: "Community & Support",
    links: [
      { to: "/legal/community-guidelines", label: "Community Guidelines" },
      { to: "/legal/student-data-policy", label: "Student Data Policy" },
      { to: "/legal/contact", label: "Contact / Grievance" },
    ],
  },
];

/**
 * Site-wide legal footer. Included on every public page (Landing, About, Marketplace,
 * Explore) and the Legal hub. Keeps Razorpay-required policy links one click away.
 */
export default function LegalFooter({ className = "" }) {
  return (
    <footer className={`border-t border-border bg-muted/30 ${className}`} data-testid="legal-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
          {FOOTER_GROUPS.map((group) => (
            <div key={group.heading}>
              <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-muted-foreground">
                {group.heading}
              </p>
              <ul className="mt-3 space-y-1.5">
                {group.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-xs text-foreground/80 hover:text-foreground transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-border/60 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-[11px] text-muted-foreground">
            © {new Date().getFullYear()} {COMPANY.legal_name}. {LEGAL_FOOTNOTE}
          </p>
          <p className="text-[11px] text-muted-foreground">
            Payments via Razorpay · All transactions in INR
          </p>
        </div>
      </div>
    </footer>
  );
}
